import { render, staticRenderFns } from "./VoteWorksAgreement.vue?vue&type=template&id=d1cb9f40"
import script from "./VoteWorksAgreement.vue?vue&type=script&lang=js"
export * from "./VoteWorksAgreement.vue?vue&type=script&lang=js"
import style0 from "./VoteWorksAgreement.vue?vue&type=style&index=0&id=d1cb9f40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports